import * as React from 'react';

function KebabIcon(props) {
  return (
    <svg width="15px" height="3px" viewBox="0 0 15 3" style={{ overflow: 'visible' }} {...props}>
      <path
        d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
        fill="#999999"
        fillRule="evenodd"
        stroke="none"
      />
      <path
        d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
        transform="translate(6 0)"
        fill="#999999"
        fillRule="evenodd"
        stroke="none"
      />
      <path
        d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
        transform="translate(12 0)"
        fill="#999999"
        fillRule="evenodd"
        stroke="none"
      />
    </svg>
    // <svg viewBox="0 0 50 50" width="1em" height="1em" {...props}>
    //   <path d="M9 19c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm16 0c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm16 0c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6z" />
    // </svg>
  );
}

export default KebabIcon;
